import React from 'react';
import './Returns.css';

function Returns() {
  return (
    <div className="returns-page">
      <div className="container">
        <section className="returns-hero">
          <h1>↩️ Easy Returns</h1>
          <p className="subtitle">30‑Day Return Policy</p>
        </section>

        <section className="returns-content">
          <p className="intro-text">
            If something isn't quite right, we've made returns simple and stress‑free. 
            You can request a return within 30 days of receiving your order, provided 
            the item is unused and in its original condition.
          </p>

          <div className="returns-policy">
            <h2>Our returns policy includes:</h2>
            <ul className="returns-list">
              <li>30‑day return window</li>
              <li>Clear and fair return guidelines</li>
              <li>Support team available to assist you</li>
              <li>Hassle‑free process designed around trust</li>
            </ul>
          </div>

          <section className="returns-commitment">
            <p>
              We want you to shop confidently, knowing we're here to help if you need us.
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Returns;
